import React from "react";
import { useTranslation } from "react-i18next";
import { Page, PageHeader } from "../../../components/ui";
import "./analytics.css";

/** Looker Studio report of the platform. */
const REPORT_URL =
  "https://lookerstudio.google.com/embed/reporting/6e799b72-ed9a-4ece-80b4-5abad7348c5d/page/4VDGB";

const Analytics = () => {
  const { t } = useTranslation();
  return (
    <Page>
      <PageHeader
        title={t("Analytics")}
        subtitle={t("Looker Studio report of the platform")}
        actions={
          <a
            className="ui-btn ui-btn-secondary"
            href={REPORT_URL.replace("/embed/", "/")}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="ri-share-box-line" aria-hidden="true"></i>
            {t("Open in a new tab")}
          </a>
        }
      />
      <section className="ui-card analytics-report">
        <iframe
          src={REPORT_URL}
          title={t("Analytics")}
          allowFullScreen
          frameBorder="0"
        />
      </section>
    </Page>
  );
};

export default Analytics;
